import React from "react";
import './tem-crd.css'
import insta from '../animations/Instagram-Logo.wine.svg'
import linke from '../animations/Linkedin-logo-icon-png.png'
import Lottie from "lottie-react";

function TemCrd({Img,Name,Position,instalink,linkedinlink}){
    return(
        <div className="tem-crd">
            <img src={Img}></img>
            <h4>{Name}</h4>
            <p>{Position}</p>
            <div className="social-media">
                <div>
                    <a href={instalink}>
                        <img src={insta} height={"34px"}/>
                    </a>
                </div>

                <div className="hi">
                    <a  href={linkedinlink}>
                        <img src={linke} height={"24px"}/>
                    </a>
                </div>
            </div>
            
        </div>
    )
}

export default TemCrd;